import './ChangeAvatar.less';
import { Upload, message, Button } from 'antd';
import ImgCrop from 'antd-img-crop';
import type { UploadProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { getConfig } from 'configs';
import { useKeycloak } from 'all-in-one-react-keycloak';
// import { useState, useRef } from 'react';
const ImgCropComponent = (changeAvatarProps: { sendAvatarStatus: () => void }) => {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const { baseApiUrl } = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'development');
  const uploadProfileAvatarUrl = `${baseApiUrl}/xapi/v1/user/setting/life-profile-image`;
  // const [imageSrc, setImageSrc] = useState('');
  // const fileInputRef = useRef<HTMLInputElement>(null);

  // const openCamera = () => {
  //   console.log(111);
  //   if (fileInputRef.current) {
  //     fileInputRef.current.click();
  //   }
  // };

  // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     // 创建一个文件读取器
  //     const reader = new FileReader();

  //     reader.onload = (e: ProgressEvent<FileReader>) => {
  //       if (e.target?.result) {
  //         setImageSrc(e.target.result as string);
  //       }
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };
  const props: UploadProps = {
    name: 'file',
    action: uploadProfileAvatarUrl,
    headers: {
      authorization: 'Bearer ' + keycloak.token,
      accept: 'application/json',
    },
    showUploadList: false,
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
        changeAvatarProps.sendAvatarStatus();
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  const imgCropProps = {
    width: 185, //裁剪宽度
    height: 185, //裁剪高度
    quality: 1, //裁切图像质量，0到1之间
    fillColor: 'white', // 裁切图像填充色
    resize: false, //裁剪是否可以调整大小
    zoomSlider: true, // 是否缩放
    rotationSlider: true, // 旋转调节
    aspectSlider: false, // 纵横调节
    // showReset: true, // 重置按钮展示
    // resetText: '重置', // 重置按钮文本
    aspect: 1, // 宽高比
    // minZoom: 1, // 最小变焦系数
    // maxZoom: 3, // 最大变焦系数
    showGrid: true, // 裁剪框网格
    resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
    modalWidth: 510, //弹窗宽度
    // cropShape: 'round', // 裁剪框是圆形还是方形 圆形:round 方形:rect (这个属性放到这里面不好使)
    // onModalOk: props.onChange, // 确定裁剪回调
    // onModalCancel: this.handleModalCancel, // 取消裁剪回调
    // beforeCrop: this.beforeCrop, // 裁剪前回调 如果返回false或reject()则停止裁剪
    // modalProps: {
    //   footer: (
    //     <>
    //       <p className="choose">{t('life.lifeProfile.or')}</p>
    //       <Button
    //         className="cancel"
    //         onClick={() => {
    //           // if (uploadRef?.current?.upload) {
    //           //   uploadRef?.current?.upload?.saveUploader();
    //           // }
    //           console.log(uploadRef?.current);
    //         }}
    //       >
    //         {t('life.lifeProfile.cancel')}
    //       </Button>
    //     </>
    //   ),
    // },
  };

  return (
    <>
      <ImgCrop
        cropShape="round"
        modalTitle={t('profile.profilePicture.editImage')}
        modalOk={t('common.ok')}
        modalCancel={t('common.cancel')}
        beforeCrop={(file) => {
          return !!file;
        }}
        modalClassName="img-crop-wrapper"
        {...imgCropProps}
      >
        <Upload {...props}>
          <Button className="upload upload-avatar-title">{t('life.lifeProfile.ProfilePic')}</Button>
        </Upload>
        {/* <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
        <button onClick={openCamera}>打开相册</button>
        {imageSrc && <img src={imageSrc} alt="Selected Image" />} */}
      </ImgCrop>
    </>
  );
};

export default ImgCropComponent;
